import React, {useContext} from "react";
import PropTypes from "prop-types";
import { LoginContext } from "../../../../services/api/authentication-api";
import { OrganizationGrid } from "../organization/OrganizationGrid";
import placeholderImage from "../../../../assets/icons/Illustration - Missing content.svg";
import {
  CustomActionsCell,
  CustomCell,
} from "../organization/CommonUtil";
import NoPermissionTable from "../../../../components/no-permission-table/NoPermissionTable";

export const DepartmentGrid = (props) => {
  const { departmentRolePrivilege, fetchEndpoint } = props;
  const user = useContext(LoginContext);

  if (!departmentRolePrivilege) {
    return (
      <div style={{height: "500px"}}>
        <NoPermissionTable />;
      </div> )
  }

  const canArchive = user?.currentUser?.privileges?.["Department"]?.Delete;
  const canEdit = user?.currentUser?.privileges?.["Department"]?.Edit ?? false;

  const columns = [
    { field: "Name", title: "Name", render: true, export: true },
    { field: "WebsiteURL", title: "Website URL", render: true, export: true },
    { field: "Address", title: "Address", render: false, export: true },
    { field: "Country", title: "Country", render: true, export: true },
    { field: "State", title: "State", render: true, export: true },
    { field: "City", title: "City", render: true, export: true },
    { field: "Zip", title: "Zip/Postal", render: true, export: true },
    {
      field: "Status",
      title: "Status",
      cells: { data: (props) => CustomCell("Status", props) },
      render: true,
      export: true,
    },
    {
      field: "",
      title: "Actions",
      cells: {
        data: (props) =>
          CustomActionsCell(props, "/admin/organization/departments/edit/", fetchEndpoint, "Department", canArchive, canEdit),
      },
      render: true,
      export: false,
    },
  ];

  const placeholderTexts = {
    firstLine: `Create your first Department for the Organization by`,
    secondLine: `clicking the 'Create New Department'`,
  };

  return (
    <span data-testid="organization-grid">
      <OrganizationGrid
        {...props}
        type="Department"
        privilegeKey="Department"
        createPath="/admin/organization/departments/create/0"
        columns={columns}
        exportFileName="Departments-Export"
        placeholderTexts={placeholderTexts}
        placeholderImage={placeholderImage}
      />
    </span>
  );
};

DepartmentGrid.propTypes = {
  fetchEndpoint: PropTypes.func,
  departmentRolePrivilege: PropTypes.bool,
};
